const DEVICE_ID_KEY = "echo:device-id";

function getDeviceId(): string {
  try {
    const existing = localStorage.getItem(DEVICE_ID_KEY);
    if (existing) return existing;

    const generated = typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(DEVICE_ID_KEY, generated);
    return generated;
  } catch {
    return "";
  }
}

export function withDeviceHeader(headers?: HeadersInit): Headers {
  const out = new Headers(headers || {});
  const deviceId = getDeviceId();
  if (deviceId) out.set("X-Echo-Device-Id", deviceId);
  return out;
}
